export const PRODUCT_START_TRACKING_GOAL = 'PRODUCT_START_TRACKING_GOAL';

export const PRODUCT_TRACKING_GOAL_SUCCESS = 'PRODUCT_TRACKING_GOAL_SUCCESS';

export const PRODUCT_TRACKING_GOAL_FAILED = 'PRODUCT_TRACKING_GOAL_FAILED';